import { MessagesWorkspace } from "@/features/messages";

export default function MessagesPage() {
  return <MessagesWorkspace />;
}
